import React, { useMemo } from 'react';
import { Card, Form, Input, Select } from '../../../../components';
import { isValidIP } from '../../../../lib/helpers';

const PUBLIC_IP_OPTIONS = [
    { value: 'dynamic', label: 'Dynamic' },
    { value: 'none', label: 'None' },
];

const validateStaticPrivateIp = async (_rule, value) => {
    if (value && !isValidIP(value)) {
        throw new Error('Static Private IP must be a valid IP address');
    }
};

export const AzureNetworkConfig = ({ networks = [], disabled = false, title = 'Network Adapter' }) => {
    const form = Form.useFormInstance();
    const selectedSubnet = Form.useWatch('subnet', form);

    const subnetOptions = useMemo(() => {
        return networks.map((network) => ({
            value: network.name,
            label: network.name + (network.cidr_block ? ` (${network.cidr_block})` : ''),
        }));
    }, [networks]);

    return (
        <Card title={title} size="small" className="network-config-card network-config-card--appliance">
            <Form.Item name="subnet" label="Subnet" rules={[{ required: true, message: 'Subnet is required' }]}>
                <Select
                    placeholder={networks.length === 0 ? 'Select a Virtual Network first' : 'Select a Subnet'}
                    options={subnetOptions}
                    disabled={disabled || networks.length === 0}
                    showSearch={{ optionFilterProp: 'label' }}
                />
            </Form.Item>

            {selectedSubnet && (
                <>
                    <Form.Item name="assignPublicIp" label="Public IP Address">
                        <Select options={PUBLIC_IP_OPTIONS} disabled={disabled} />
                    </Form.Item>

                    <Form.Item
                        name="staticPrivateIp"
                        label="Static Private IP"
                        rules={[{ validator: validateStaticPrivateIp }]}
                    >
                        <Input placeholder="Enter static private IP (optional)" disabled={disabled} />
                    </Form.Item>
                </>
            )}
        </Card>
    );
};

